import React from 'react'
import {Link} from "react-router-dom"
import { useTranslation } from 'react-i18next';
import { RiInstagramFill } from "react-icons/ri";
import { FaLocationDot, FaPhone, FaMessage } from "react-icons/fa6";

const Footer = () => {
  const { t } = useTranslation();

  return (
  <footer className='bg-white p-6'>
    <div className='container py-10 mx-auto'>

    {/* <div className='md:w-2/5 w-2/4'>
        <img src={Logo} alt="Logo" className='md:w-2/5'/>
      </div> */}

    <div className="flex md:flex-row flex-col gap-10 md:mt-10 mt-4 justify-between items-start">
      <div className='md:w-1/5'>
        <h2 className='text-xl font-Merriweather '>{t('aboutArtistrySpawellnes')}</h2>
        <p className='!leading-relaxed md:mt-5 mt-2 text-sm'>{t('footerText')}</p>
      </div>

      <div className=''>
      <h2 className='text-xl font-Merriweather '>{t('usefullLinks')}</h2>
      <ul className='md:mt-5 mt-2'>
        <li className='my-2 text-sm' onClick={() => window.scrollTo({top: 0, behavior: 'smooth'})}>
          <Link to="/">
          {t('home')}
          </Link>
        </li>
        <li className='my-2 text-sm' onClick={() => window.scrollTo({top: 0, behavior: 'smooth'})}>
          <Link to="/about">
          {t('about')}
          </Link>
        </li>
        <li className='my-2 text-sm' onClick={() => window.scrollTo({top: 0, behavior: 'smooth'})}>
          <Link to="/priceList">
          {t('priceList')}
          </Link>
        </li>
        <li className='my-2' onClick={() => window.scrollTo({top: 0, behavior: 'smooth'})}>
          <Link to="/services">
          {t('services')}
          </Link>
        </li>
        <li className='my-2 text-sm' onClick={() => window.scrollTo({top: 0, behavior: 'smooth'})}>
          <Link to="/contact">
          {t('contact')}
          </Link>
        </li>
      </ul>
      </div>

      <div className='md:w-2/6'>
      <h2 className='text-xl font-Merriweather '>{t('contactInfo')}</h2>
      <p className='md:mt-5 text-sm mt-2'><Link className='flex gap-5' to='https://www.google.com/maps?ll=39.971749,-75.137615&z=15&t=h&hl=en&gl=US&mapclient=embed&cid=7065574351132850926' target='_blank'><FaLocationDot className='text-[rgb(161,121,61)] text-2xl'/> {t('ourAddress')}</Link></p>
      <p className='mt-3 text-sm'><a href="tel:267-593-1205" className='flex gap-5'><FaPhone className='text-[rgb(161,121,61)] text-xl'/> 267-593-1205</a></p>
      <p className='mt-3 text-sm'><a href="mailto:mailto:artistryspanwellness@gmail.com" className='flex gap-5'><FaMessage className='text-[rgb(161,121,61)] text-xl'/> artistryspanwellness@gmail.com</a></p>
      <p className='mt-3 text-sm'>
        <Link to="https://www.instagram.com/artistry_spa_wellness" target='_blank' className='flex gap-5'><RiInstagramFill className='text-[rgb(161,121,61)] text-2xl'/>Follow Us</Link>
      </p>
      </div>

      {/* <div className='md:w-1/5'>
        <h2 className='text-xl font-Merriweather '>{t('subsOurNewsletter')}</h2>
        <p className='!leading-relaxed md:mt-5 mt-2 text-sm'>{t('newsLetterText')}</p>
        <form className="flex items-center mt-5" onSubmit={handleSubmit}>
                <input type="email" required name="email" className='p-3 bg-gray-50 pr-5 w-full rounded-md' placeholder={t('contactInputPlaceholder')}/>
                <button className='p-3.5 rounded-s-none px-5 rounded-md bg-[rgb(111,91,33)] text-white font-semibold'><IoIosSend/></button>
        </form>
      </div> */}


    </div>

    </div>
    <div className='p-5 border-t txet-sm border-[rgb(161,121,61)] text-center'>
      {t("allRightSeserve").replace(/\d{4}/, new Date().getFullYear())}
    </div>
  </footer>
  )
}

export default Footer